import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="kartenfilter-form"
export default class extends Controller {
	static targets = [
		"hiddenFieldLabel",
		"hiddenFieldZustaendiger",
		"hiddenFieldErledigt",
		"inputFieldFristVon",
		"inputFieldFristBis",
		"labelContainer",
		"zustaendigerContainer",
		"erledigtContainer",
	]

	connect() {}

	updateLabel({ currentTarget }) {
		// hidden_field updaten
		this.hiddenFieldLabelTarget.value = currentTarget.dataset.labelvalue
		// SVG-Farbe updaten
		const svgElement = this.labelContainerTarget.querySelector("svg")
		svgElement.classList.forEach((cls) => {
			if (cls.startsWith("fill-")) svgElement.classList.remove(cls)
		})
		svgElement.classList.add(
			this.getFarbeLabel(currentTarget.dataset.labelvalue),
		)
		// Label-Text updaten
		const textElement = this.labelContainerTarget.querySelector("div")
		textElement.innerHTML = currentTarget.querySelector("span").innerHTML
		// Selectbox updaten
		const elements = this.element.querySelectorAll("[data-labelvalue]")
		elements.forEach((element) => {
			element.classList.remove("!border-gray-300")
		})
		currentTarget.classList.add("!border-gray-300")
		// Remove-Icon hinzufügen
		this.element
			.querySelector("#kartenfilter_label_remove_icon")
			.classList.remove("hidden")
		// Formular abschicken
		this.submit()
	}

	removeLabel() {
		// hidden_field updaten
		this.hiddenFieldLabelTarget.value = "ohne"
		// SVG-Farbe updaten
		const svgElement = this.labelContainerTarget.querySelector("svg")
		svgElement.classList.forEach((cls) => {
			if (cls.startsWith("fill-")) svgElement.classList.remove(cls)
		})
		svgElement.classList.add("fill-farbe-grau")
		// Label-Text updaten
		const textElement = this.labelContainerTarget.querySelector("div")
		textElement.innerHTML = "Label filtern"
		// Selectbox updaten
		const elements = this.element.querySelectorAll("[data-labelvalue]")
		elements.forEach((element) => {
			element.classList.remove("!border-gray-300")
		})
		// Remove-Icon entfernen
		this.element
			.querySelector("#kartenfilter_label_remove_icon")
			.classList.add("hidden")
		// Formular abschicken
		this.submit()
	}

	updateZustaendiger({ currentTarget }) {
		// hidden_field updaten
		this.hiddenFieldZustaendigerTarget.value = currentTarget.dataset.userid
		// Name updaten
		const nameElement =
			this.zustaendigerContainerTarget.querySelector("div")
		nameElement.innerHTML = currentTarget.innerHTML
		// Selectbox updaten
		const elements = this.element.querySelectorAll("[data-userid]")
		elements.forEach((element) => {
			element.classList.remove("!border-gray-300")
		})
		currentTarget.classList.add("!border-gray-300")
		// Remove-Icon hinzufügen
		this.element
			.querySelector("#kartenfilter_zustaendiger_remove_icon")
			.classList.remove("hidden")
		// Formular abschicken
		this.submit()
	}

	removeZustaendiger() {
		// hidden_field updaten
		this.hiddenFieldZustaendigerTarget.value = ""
		// Name updaten
		const nameElement =
			this.zustaendigerContainerTarget.querySelector("div")
		nameElement.innerHTML = "Zuständigen filtern"
		// Selectbox updaten
		const elements = this.element.querySelectorAll("[data-userid]")
		elements.forEach((element) => {
			element.classList.remove("!border-gray-300")
		})
		// Remove-Icon entfernen
		this.element
			.querySelector("#kartenfilter_zustaendiger_remove_icon")
			.classList.add("hidden")
		// Formular abschicken
		this.submit()
	}

	updateErledigt({ currentTarget }) {
		// hidden_field updaten
		this.hiddenFieldErledigtTarget.value =
			currentTarget.dataset.erledigtvalue
		// SVG-Farbe updaten
		const svgElement = this.erledigtContainerTarget.querySelector("svg")
		svgElement.classList.forEach((cls) => {
			if (cls.startsWith("fill-")) svgElement.classList.remove(cls)
		})
		svgElement.classList.add(
			this.getFarbeErledigt(currentTarget.dataset.erledigtvalue),
		)
		// Erledigt-Text updaten
		const textElement = this.erledigtContainerTarget.querySelector("div")
		textElement.innerHTML = currentTarget.querySelector("span").innerHTML
		// Selectbox updaten
		const elements = this.element.querySelectorAll("[data-erledigtvalue]")
		elements.forEach((element) => {
			element.classList.remove("!border-gray-300")
		})
		currentTarget.classList.add("!border-gray-300")
		// Remove-Icon hinzufügen
		this.element
			.querySelector("#kartenfilter_erledigt_remove_icon")
			.classList.remove("hidden")
		// Formular abschicken
		this.submit()
	}

	removeErledigt() {
		// hidden_field updaten
		this.hiddenFieldErledigtTarget.value = ""
		// SVG-Farbe updaten
		const svgElement = this.erledigtContainerTarget.querySelector("svg")
		svgElement.classList.forEach((cls) => {
			if (cls.startsWith("fill-")) svgElement.classList.remove(cls)
		})
		svgElement.classList.add("fill-farbe-grau")
		// Erledigt-Text updaten
		const textElement = this.erledigtContainerTarget.querySelector("div")
		textElement.innerHTML = "Status filtern"
		// Selectbox updaten
		const elements = this.element.querySelectorAll("[data-erledigtvalue]")
		elements.forEach((element) => {
			element.classList.remove("!border-gray-300")
		})
		// Remove-Icon entfernen
		this.element
			.querySelector("#kartenfilter_erledigt_remove_icon")
			.classList.add("hidden")
		// Formular abschicken
		this.submit()
	}

	updateFristVon() {
		this.formatiereFristVon()

		// Remove-Icon hinzufuegen oder entfernen
		if (this.inputFieldFristVonTarget.value == "") {
			this.element
				.querySelector("#kartenfilter_frist_von_remove_icon")
				.classList.add("hidden")
		} else {
			this.element
				.querySelector("#kartenfilter_frist_von_remove_icon")
				.classList.remove("hidden")
		}
		// Formular abschicken
		this.submit()
	}

	updateFristVonOnEnter(event) {
		if (event.key === "Enter" && !event.shiftKey) {
			event.target.parentNode.parentNode.dispatchEvent(
				new Event("click", { bubbles: true }),
			) // Irgendwo hinklicken, damit Dropdown zu geht
			event.target.blur() // entfernt den Fokus vom aktuellen Element
			this.updateFristVon()
		}
	}

	updateFristBis() {
		this.formatiereFristBis()

		// Remove-Icon hinzufuegen oder entfernen
		if (this.inputFieldFristBisTarget.value == "") {
			this.element
				.querySelector("#kartenfilter_frist_bis_remove_icon")
				.classList.add("hidden")
		} else {
			this.element
				.querySelector("#kartenfilter_frist_bis_remove_icon")
				.classList.remove("hidden")
		}
		// Formular abschicken
		this.submit()
	}

	updateFristBisOnEnter(event) {
		if (event.key === "Enter" && !event.shiftKey) {
			event.target.parentNode.parentNode.dispatchEvent(
				new Event("click", { bubbles: true }),
			) // Irgendwo hinklicken, damit Dropdown zu geht
			event.target.blur() // entfernt den Fokus vom aktuellen Element
			this.updateFristBis()
		}
	}

	addFristVonPlaceholderInfo() {
		this.inputFieldFristVonTarget.placeholder = "TT.MM.JJJJ"
	}

	addFristBisPlaceholderInfo() {
		this.inputFieldFristBisTarget.placeholder = "TT.MM.JJJJ"
	}

	removeFristVonPlaceholderInfo() {
		setTimeout(() => {
			this.inputFieldFristVonTarget.placeholder = "Frist von"
		}, 200)
	}

	removeFristBisPlaceholderInfo() {
		setTimeout(() => {
			this.inputFieldFristBisTarget.placeholder = "Frist bis"
		}, 200)
	}

	removeFristVon() {
		// input_field updaten
		this.inputFieldFristVonTarget.value = ""
		// placeholder updaten
		this.removeFristVonPlaceholderInfo
		// Remove-Icon entfernen
		this.element
			.querySelector("#kartenfilter_frist_von_remove_icon")
			.classList.add("hidden")
		// Formular abschicken
		this.submit()
	}

	removeFristBis() {
		// input_field updaten
		this.inputFieldFristBisTarget.value = ""
		// placeholder updaten
		this.removeFristBisPlaceholderInfo
		// Remove-Icon entfernen
		this.element
			.querySelector("#kartenfilter_frist_bis_remove_icon")
			.classList.add("hidden")
		// Formular abschicken
		this.submit()
	}

	submit() {
		this.element.requestSubmit()
	}

	// private

	getFarbeLabel(farbe) {
		const farbeMap = {
			ohne: "fill-farbe-grau",
			blau: "fill-labelblau",
			gruen: "fill-labelgruen",
			lila: "fill-labellila",
			gelb: "fill-labelgelb",
			rot: "fill-labelrot",
		}
		return farbeMap[farbe]
	}

	getFarbeErledigt(value) {
		const farbeMap = {
			0: "fill-farbe-grau",
			1: "fill-[#9FD356]",
		}
		return farbeMap[value]
	}

	formatiereFristVon() {
		const date = moment(this.inputFieldFristVonTarget.value, "DDMMYYYY")

		if (date.isValid()) {
			this.inputFieldFristVonTarget.value = date.format("DD.MM.YYYY")
		} else {
			this.inputFieldFristVonTarget.value = ""
		}
	}

	formatiereFristBis() {
		const date = moment(this.inputFieldFristBisTarget.value, "DDMMYYYY")

		if (date.isValid()) {
			this.inputFieldFristBisTarget.value = date.format("DD.MM.YYYY")
		} else {
			this.inputFieldFristBisTarget.value = ""
		}
	}
}
